export const CARD_SPRING_TENSION = 130
export const ANIMATION_DISABLED_DURATION = 0
